export const stringTrimmer = (string: string, length: number) => {
  return string.length > length ? `${string?.slice(0, length)}...` : string;
};
